import type { FeatureRequestCategory } from "@shared/schemas/featureRequest";

/**
 * Order of category options in the select. Labels come from i18n
 * (`t.featureRequest.category.*`) so the array stays language-agnostic.
 */
export const FEATURE_REQUEST_CATEGORY_OPTIONS: readonly {
  value: FeatureRequestCategory;
  /** i18n key under `t.featureRequest.category.*`. */
  labelKey: "newFlow" | "improveFlow" | "pricing" | "account" | "other";
}[] = [
  { value: "new_flow", labelKey: "newFlow" },
  { value: "improve_flow", labelKey: "improveFlow" },
  { value: "pricing", labelKey: "pricing" },
  { value: "account", labelKey: "account" },
  { value: "other", labelKey: "other" },
] as const;
